(function () {
  /**
   * @deprecated remove the whole system-group folder with temp_cc_spaces
   *
   * @ngdoc factory
   * @name SystmeGroupList
   * @description Model for a list of system groups
   *   The SYSTEM_GROUP.EVERYBODY ('_everybody') group can be used to get the count of users.
   *   If you just need the user count this is much more performant than using userList.
   */
  angular
    .module('binky.core.organizations.system-group')
    .factory('SystemGroup', getSystemGroupModel);

  /* @ngInject */
  function getSystemGroupModel(
    $log,
    $q,
    _,

    jilSystemGroups,
    Member,
    MEMBER_EVENT,
    MEMBER_TYPE,
    modelCache,
    SYSTEM_GROUP
  ) {
    class SystemGroup extends Member {
      /**
       * @description Creates a new SystemGroup.
       *
       * @param {Object} options - options for the new system group
       * @param {String} options.name - the name of the group
       * @param {String} [options.orgId] - associates SystemGroup instance with an org.
       */
      constructor(options) {
        super(options);
        updateModel(this, options);
        this.orgId = options.orgId;
      }

      getDisplayName() {
        return this.name;
      }

      /**
       * @description Method to refresh the current model state against what is
       *              stored in the back-end.
       *
       * @return {Promise} resolves to the refreshed SystemGroup model, else rejects
       *                   with error message.
       */
      refresh() {
        this.$resolved = false;

        this.$promise = $q((resolve, reject) => {
          jilSystemGroups.systemGroups.get(
            _.omitBy({groupName: this.name, orgId: this.orgId}, _.isUndefined),
            (response) => {
              updateModel(this, response);
              modelCache.put(SYSTEM_GROUP.CACHE_ID, this, this.name);
              this.$resolved = true;
              resolve(this);
            },
            (error) => {
              modelCache.put(SYSTEM_GROUP.CACHE_ID, {}, this.name);
              $log.error('SystemGroup failed to load. Error: ', error);
              this.$resolved = true;
              reject(error);
            }
          );
        });

        return this.$promise;
      }

      /**
       * @description Method to retrieve an existing UserGroup from back-end data
       *              store.
       *
       * @param {Object} options - the options
       * @param {String} [options.name] - the group name to retrieve.
       *   Default is '_everybody' which gets the total count of users.
       * @param {String} [options.orgId] - associates SystemGroup instance with an org.
       * @returns {SystemGroup} the new SystemGroup model with a pending promise
       */
      static get({name, orgId} = {}) {
        const groupName = name || SYSTEM_GROUP.EVERYBODY;
        let model = new SystemGroup({name: groupName, orgId});
        const cachedModel = modelCache.get(SYSTEM_GROUP.CACHE_ID, groupName);
        if (cachedModel) {
          model = cachedModel;
        } else {
          model.refresh();
        }
        return model;
      }
    }

    // We register the cache size for this class
    modelCache.register(SYSTEM_GROUP.CACHE_ID, 1);
    modelCache.removeAllOnEvent(SYSTEM_GROUP.CACHE_ID, [MEMBER_EVENT.CREATE, MEMBER_EVENT.DELETE]);

    return SystemGroup;

    ////////////

    function updateModel(model, options) {
      model.type = MEMBER_TYPE.USER_GROUP;
      _.assign(model, _.pick(options, ['id', 'name', 'userCount']));
    }
  }
})();
